module.exports = __webpack_public_path__ + "static-portal/img/news14-2.4d5febb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news14-2.png
// module id = LtHK
// module chunks = 4